import React from 'react'
import usePageMeta from '../hooks/usePageMeta'
import Navbar from '../components/navbar/Navbar'
import HeaderCurriculum from '../components/header_curriculum/HeaderCurriculum'
import CurriculumInfo from '../components/header_curriculum/CurriculumInfo'
import Footer from '../components/footer/Footer'
import Programs from '../components/programs/Programs'

export default function CurriculumPage() {
  usePageMeta({
    title: 'Preschool Curriculum & Programs | Learning In Motion Preschool',
    description: 'Frog Street curriculum for wobblers, toddlers, preschool and VPK at our Cooper City, FL preschool.',
    path: '/curriculum',
  })

  return (
    <>
      <Navbar/>
      <HeaderCurriculum/>
      <CurriculumInfo/>
      <Programs/>
      <Footer/>
    </>
  )
}
